import { Injectable, inject } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { ManageUserComponent } from '../tpi-components/manage-accounts-company-web/manage-user/manage-user.component';
import { LoggerService } from '../tpi-services/logger/logger.service';

@Injectable({
    providedIn: 'root'
})
export class UnsavedChangesGuard implements CanDeactivate<ManageUserComponent> {
    private logger = inject(LoggerService);

    // accept optional router parameters so callers (and tests) can pass route/state
    // keep parameters to a maximum of 3 to satisfy lint rules
    canDeactivate(component: ManageUserComponent, currentRoute?: any, currentState?: any): boolean {
        const formDirty = !!component.manageUserForm && component.manageUserForm.dirty;
        const allowNavigation = !!component.allowNavigation;
        const saved = !!component.successfulUpdate;

        if (formDirty && !saved && !allowNavigation) {
            this.logger?.info('UnsavedChangesGuard: preventing navigation due to unsaved changes');
            component.isUnsavedChangesModalOpen = true;
            return false;
        }

        // navigation allowed -> clear transient flags on the component
        if (component.resetNavigationFlags && typeof component.resetNavigationFlags === 'function') {
            component.resetNavigationFlags();
        } else {
            // fall back for test mocks that don't implement resetNavigationFlags
            component.successfulUpdate = false;
            component.allowNavigation = false;
        }
        return true;
    }
}